var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-100 vertical-flex-container" }, [
    _c("div", { staticClass: "vertical-flex-auto" }, [
      _c("div", { staticClass: "row no-gutters mb-2" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xl-auto col-lg-2 col-md-3 col-sm-6 pr-sm-1 text-center text-xl-left mb-lg-0 mb-3",
          },
          [
            _c("application-flow-dropdown", {
              directives: [
                {
                  name: "disable-all-inputs",
                  rawName: "v-disable-all-inputs",
                  value: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
                  expression: "CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY",
                },
              ],
              staticClass: "card flow-dropdown px-3 mb-0",
              attrs: {
                flows: _vm.flows,
                "current-flow": _vm.CURRENT_APPLICATION.flow,
                "application-id": _vm.applicationId,
                "client-username": _vm.clientUsername,
                badge: false,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-xl col-lg-10 col-md-9 col-sm-6 small-nav-wrapper pl-sm-1",
          },
          [
            _c("application-dropdown-navigation", {
              staticClass: "col-12",
              attrs: {
                page: _vm.currentPage,
                application: _vm.CURRENT_APPLICATION,
              },
              on: { "page-change": _vm.handlePageChange },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "mortgageContainer",
        staticClass: "pr-1 vertical-flex-fit",
        attrs: { id: "app-data-container" },
      },
      [
        _c("application-form", {
          directives: [
            {
              name: "disable-all-inputs",
              rawName: "v-disable-all-inputs",
              value: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
              expression: "CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY",
            },
          ],
          attrs: {
            "current-page": _vm.currentPage,
            "application-id": _vm.applicationId,
            "client-username": _vm.clientUsername,
            "client-details": _vm.clientDetails,
            "agent-username": _vm.agentUsername,
          },
          on: { "page-change": _vm.handlePageChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }